/** @jsx jsx **/
import { IconButton, jsx } from 'theme-ui'
import { FC } from 'react'
import GatorArrow from '~/components/icons/arrowSecondary'
import { ArrowDirection } from '~/@types/models'

type Props = ArrowDirection & {
  hideCircle?: boolean
  width?: number
  height?: number
  arrowSpace?: number | [number, number]
  top?: string | [string, string]
}

const ArrowSecondary: FC<Props> = ({
  hideCircle = false,
  width = 48,
  height = 48,
  top = '36%',
  direction,
  arrowSpace = 0,
  ...rest
}) => (
  <IconButton
    {...rest}
    sx={{
      backgroundColor: 'transparent !important',
      width,
      height,
      top: top,
      transform: 'translateY(-50%)',
      position: 'absolute',
      zIndex: 1,
      cursor: 'pointer',
      ...(direction === 'left' && {
        left: arrowSpace,
      }),
      ...(direction === 'right' && {
        right: arrowSpace,
      }),
    }}
  >
    <GatorArrow direction={direction} hideCircle={hideCircle} />
  </IconButton>
)

export default ArrowSecondary
